import { JSXElement, mergeProps, Show } from 'solid-js';
import { Tag } from '~/components/ui/Tag';
import { Localized } from '~/i18n';
import { ConnectionData } from '~/api/types/connectionData.ts';
import { getTranslationKey } from '~/pages/ScalekitConnect/Integrations/utils.tsx';

type ConnectionStatusTagProps = {
  connectedApp: ConnectionData;
};

export default function ConnectionStatusTag(
  props: ConnectionStatusTagProps
): JSXElement {
  const merged = mergeProps({}, props);
  return (
    <Show
      when={merged.connectedApp.enabled}
      fallback={
        <Tag
          variant={`secondary`}
          class={`inline-flex mx-0`}
        >
          <Localized
            translationKey={getTranslationKey('connection_status_disabled')}
          />
        </Tag>
      }
    >
      <Tag
        variant={`success`}
        class={`inline-flex mx-0`}
      >
        <Localized
          translationKey={getTranslationKey('connection_status_enabled')}
        />
      </Tag>
    </Show>
  );
}
